"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBaseApi = exports.SEARCH_API_ERROR = exports.FACET_PREFIX = exports.PAGE_SIZE = exports.MAX_PAGE_SIZE = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var json2typescript_1 = require("json2typescript");
var UtilService_1 = require("../UtilService");
exports.MAX_PAGE_SIZE = 2147483647;
exports.PAGE_SIZE = 10;
exports.FACET_PREFIX = 'facet_';
exports.SEARCH_API_ERROR = 'SEARCH_API_ERROR';
var SearchBaseApi = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBaseApi, _super);
    function SearchBaseApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildUrl = function (endPoint, params) { return "".concat(endPoint, "?").concat(_this.buildQuery(params)); };
        _this.retryCallApiOnFail = function (urlWithParams) {
            return UtilService_1.UtilService.PromiseRetryPolicy(_super.prototype.callApi.bind(_this, urlWithParams, {}), 3);
        };
        return _this;
    }
    SearchBaseApi.prototype.doSearch = function (params, classReference) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.getData(params).then(function (data) {
                        var jsonConvert = new json2typescript_1.JsonConvert();
                        return jsonConvert.deserialize(data, classReference);
                    })];
            });
        });
    };
    // Extended from BaseApi
    SearchBaseApi.prototype.callApi = function (url, params) {
        var urlWithParams = this.buildUrl(url, params);
        return this.retryCallApiOnFail(urlWithParams);
    };
    // Extended from BaseApi
    SearchBaseApi.prototype.throwException = function (message, responseData, _name) {
        if (_name === void 0) { _name = ''; }
        return _super.prototype.throwException.call(this, message, responseData, exports.SEARCH_API_ERROR);
    };
    // Extended from BaseApi
    SearchBaseApi.prototype.createHeaders = function () {
        return {
            requestId: UtilService_1.UtilService.newUUID(),
        };
    };
    return SearchBaseApi;
}(app_1.BaseApi));
exports.SearchBaseApi = SearchBaseApi;
